import { callApi, makeApiRequest } from "./ApiService";
import axios from "axios";
import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
} from "./Urls";

let getRecords = async (
  tabID,
  pageSize,
  orderBy = -1,
  filters = "{}",
  index = 1,

  searchVal = "",

  onComplete,
) => {
  const url = `${BaseUrl}/api/Dynamic/GetRecords?tabErpID=${tabID}`;

  const jsonBody = {
    pgSize: pageSize,
    viewFormat: "columnname",
    filterButtons: "",
    index: index,
    toEmailID: "admin@dialerp.com",
    tabErpID: tabID,
    useAtlusSearch: false,
    RoleID: 0,
    LedgerID: LoggedInUserID ? LoggedInUserID : 1002,
    order: orderBy,
    orderBy: "",
    processID: 1,
    filters: filters,
  };

  const authKey = Authorization_Token == "" ? staticToken : Authorization_Token;

  // console.log("get records req", jsonBody);

  callApi(
    url,
    jsonBody,
    authKey,
    (response) => {
      try {
        const data =
          typeof response === "string" ? JSON.parse(response) : response;

        // console.log("user details res --", data);

        if (data?.hasErrors === false) {
          onComplete(data);
        } else {
          onComplete(data); // backend returned error object
        }
      } catch (err) {
        console.error("JSON Parse Error", err);
        onComplete(null);
      }
    },
    (error) => {
      console.error("API Error", error.message || "Unknown Error");
      onComplete(null);
    },
  );
};

let PostRecords = async (
  tabID,
  pageSize,
  jsonBody,

  onComplete,
) => {
  const url = `${BaseUrl}/api/Dynamic/AddUpdateRecords?tabErpID=${tabID}`;

  const authKey = Authorization_Token == "" ? staticToken : Authorization_Token;

  // console.log("get records req", jsonBody);

  callApi(
    url,
    jsonBody,
    authKey,
    (response) => {
      try {
        const data =
          typeof response === "string" ? JSON.parse(response) : response;

        console.log("user details res --", data);

        if (data?.hasErrors === false) {
          onComplete(data);
        } else {
          onComplete(data); // backend returned error object
        }
      } catch (err) {
        console.error("JSON Parse Error", err);
        onComplete(null);
      }
    },
    (error) => {
      console.error("API Error", error.message || "Unknown Error");
      onComplete(null);
    },
  );
};

 async function uploadMultipleFiles({
  files,            // File[] (from input or drag-drop)
 
}) {
  console.log("files", files);
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("ImgFile", file);
  });

  const url = `${"https://landpandawebapi.azurewebsites.net"}/api/uploadData/addOpenRecordsImagesV1_new?userID=1002&subscriberID=10027&tabErpID=384&recordID=0`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${""}`,
        Accept: "application/json",
      },
      body: formData,
    });

    const data = await response.json();

    // Extract image URLs
    if (Array.isArray(data?.response)) {
      return data.response
        .map(item => item.imageUrl)
        .filter(Boolean);
    }

    return [];
  } catch (error) {
    console.error("Upload failed:", error);
    return [];
  }
}

async function uploadFile(file) {
  try {
    if (!file || !(file instanceof Blob)) {
      console.error("Invalid file provided:", file);
      return null;
    }

    const uniqueFileName = `${Date.now()}_${file.name}`;

    const formData = new FormData();
    formData.append("Files", file, uniqueFileName);

    const response = await fetch(
      "https://apierp.azurewebsites.net/api/UploadData/getWebUploadImgUrl?userID=40000&parentID=40000",
      {
        method: "POST",
        headers: {
          "Authorization-Token": "", // add token if required
          UserID: "40000",
          PartyAcTbSr: "40000",
          ParentID: "40000",
        },
        body: formData,
      },
    );

    if (!response.ok) {
      console.error("Upload failed:", response.statusText);
      return null;
    }

    const data = await response.json();
    return data?.response ?? null;
  } catch (error) {
    console.error("Upload error:", error);
    return null;
  }
}

export { getRecords, PostRecords, uploadMultipleFiles,uploadFile };
